import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import {store} from './features/store'
import './assets/css/bootStrap/bootstrap.min.css';
import './assets/css/bootStrap/bootstrap.rtl.only.min.css';
import 'react-circular-progressbar/dist/styles.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'react-image-lightbox/style.css';
import 'video.js/dist/video-js.css';
import './assets/css/simple-line-icons/css/simple-line-icons.css'
import './assets/css/iconsmind-s/css/iconsminds.css'

import
{
  isMultiColorActive,
  defaultColor,
  isDarkSwitchActive,
} from './constants/defaultValues';
import './assets/css/sass/themes/gogo.light.purplemonster.scss';
import { getCurrentColor, setCurrentColor } from './helpers/Utils';
const color =
  isMultiColorActive || isDarkSwitchActive ? getCurrentColor() : defaultColor;
setCurrentColor(color);
ReactDOM.render(
  <BrowserRouter basename="/">
    <Provider store={store}>
    <App />
   </Provider>
  </BrowserRouter>,
  document.getElementById("root")
);
reportWebVitals();
